import React, { useState } from "react";
import { Segment } from "semantic-ui-react";
import ICategory from "../../interfaces/ICategory";
import _chunk from 'lodash/chunk'
import FormListModal from "./FormListModal";
import CategoryMenuItem from './FormCategoryMenuItem'
import { EPermissionLevel } from "../../interfaces/ICategoryPermission";
import { MinimumCategoryPermission } from "../permissions/MinimumCategoryPermission";

interface IFormCategoryMenuProps {
    categories: ICategory[]
}

const FormCategoryMenu: React.FC<IFormCategoryMenuProps> = (props) => {
    const { categories } = props;
    const [activeCategory, setActiveCategory] = useState<number | undefined>();

    const handleMenuItemClick = (e: any, categoryId: number) => {
        setActiveCategory(categoryId);
    };

    const handleModalClose = () => {
        setActiveCategory(undefined);
    };

    const activeCategoryData = categories.find(({ id }) => activeCategory === id);
    const chunks = _chunk(categories, 2);

    return (
        <Segment.Group className="category-buttons">
            {categories.length > 1 ? (
                chunks.map((group, index) => (
                    <Segment.Group key={index} horizontal>
                        {group.map((category) => (
                            <MinimumCategoryPermission
                                key={category.id}
                                categoryId={category.id}
                                minimumPermission={EPermissionLevel.OnlyPublic}
                                permissionType="create"
                            >
                                <CategoryMenuItem
                                    key={category.id}
                                    category={category}
                                    onClick={handleMenuItemClick}
                                />
                            </MinimumCategoryPermission>

                        ))}
                    </Segment.Group>
                ))
            ) : categories.map((category) => (
                <CategoryMenuItem
                    key={category.id}
                    category={category}
                    onClick={handleMenuItemClick}
                    segmentProps={{ padded: true }}
                />
            ))}

            {activeCategory && activeCategoryData ? (
                <FormListModal
                    category={activeCategoryData}
                    open={true}
                    closeIcon={true}
                    dimmer="blurring"
                    onClose={handleModalClose}
                />
            ) : null}
        </Segment.Group>
    );
};

export default FormCategoryMenu;
